import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../components/Header";
import { Box, Typography } from "@material-ui/core";
import { cndWrapperURL, sdkWrapperURL } from "../Util/ApiAxios";
import Loader from "react-loader-spinner";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";

const PatientAppointments = () => {
  const classes = useStyles();
  const history = useHistory();
  const [isLoading, setLoading] = React.useState(false);
  const [infoCND, setInfoCND] = React.useState("");

  const pd_id = JSON.parse(localStorage.getItem("dhct_patient")).pd_id;
  useEffect(() => {
    setLoading(true);
    const Token = localStorage.getItem("dhct_Token");
    axios
      .post(
        sdkWrapperURL("/auth/refresh-token"),
        {
          pd_id,
          platform_name: "DHCT",
          response_platform_name: "CARENOWDOC-DOCTOR",
        },
        { headers: { Authorization: Token } }
      )
      .then((resp) => {
        if (resp.data.statusCode === 200) {
          setInfoCND(
            JSON.stringify({
              pd_id: pd_id,
              dr_token: Token,
              user: {
                ...(resp.data.user ?? {}),
                id_token: resp.data.token,
                user_id: resp.data.id,
              },
              hospital_details: resp.data.hospital_details,
            })
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [pd_id]);

  return (
    <div
      className="iframe-container"
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <div>
        {/* <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        /> */}

        <Header />
        <Box className={classes.Pagecontent}>
          {/* <Box className={classes.Leftcol}>
            <Box className={classes.leftnav}>
              <Patientinfo />
              <Box className={classes.TabPatientinfo}>
                <LeftNav />
              </Box>
            </Box>
          </Box> */}
          <Box className={classes.Rightcol}>
            <Typography
              style={{
                marginBottom: "20px",
                alignItems: "center",
                alignSelf: "center",
                display: "flex",
                color: "#114ebd",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => history.goBack()}
            >
              <BiArrowBack className={classes.backarrow} />
              Go Back
            </Typography>
            {isLoading ? (
              <Loader
                type="ThreeDots"
                color="#114ebd"
                height={75}
                width={75}
                timeout={0}
                className={classes.loader}
              />
            ) : (
              <iframe
                src={cndWrapperURL(
                  `/doctor/pendingRedirect?${new URLSearchParams({
                    data: infoCND,
                    patient_id: pd_id,
                  }).toString()}`
                )}
                sandbox="allow-same-origin allow-scripts allow-forms allow-downloads allow-popups"
                allow="autoplay; fullscreen; camera; microphone; geolocation; display-capture download"
                title="Pending Appointments"
                width="100%"
                height="100%"
                style={{
                  border: "none",
                  overflow: "hidden",
                  minHeight: "100vh",
                }}
              />
            )}
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default PatientAppointments;
const useStyles = makeStyles(() => ({
  Pagecontent: {
    width: "100%",
    display: "flex",
    textAlign: "left",
  },
  TabPatientinfo: {
    "@media only screen and (max-width: 820px)": {
      display: "none",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  Leftcol: {
    width: "22%",
    background: "linear-gradient(45deg, #114ebd, #0f3d6e)",
    padding: "20px 3%",
    position: "relative",
    minHeight: "1050px",
    "@media only screen and (max-width: 1200px)": {
      width: "24%",
      padding: "20px 1%",
    },
    "@media only screen and (max-width: 820px)": {
      position: "absolute",
      background: "none",
      width: "98%",
      padding: "20px 1%",
      minHeight: 35,
    },
    "@media only screen and (max-width: 768px)": {
      position: "absolute",
      background: "none",
      width: "98%",
      padding: "20px 1%",
      minHeight: 35,
    },
  },
  leftnav: {
    position: "absolute",
    top: "15px",
    bottom: "15px",
    left: "40px",
    right: "40px",
    "@media only screen and (max-width: 1200px)": {
      left: "20px",
      right: "20px",
    },
  },
  Rightcol: {
    width: "100%",
    padding: "20px 3%",
    borderLeft: "1px #F6F6F6 solid",
    "@media only screen and (max-width: 1200px)": {
      width: "100%",
      padding: "0 1%",
    },
    "@media only screen and (max-width: 820px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 60,
    },
    "@media only screen and (max-width: 768px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 60,
    },
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minHeight: "40px",
    },
  },
  loader: {
    marginLeft: "50%",
    marginTop: "20%",
  },
  backarrow: {
    color: "#114ebd",
    fontSize: "20px",
    marginRight: "8px",
  },
}));
